function marketTime(value, timeZone, zoneLabel) {
  if (!value) return null;
  const instant = new Date(value);
  if (!Number.isFinite(instant.valueOf())) return null;
  const formatted = new Intl.DateTimeFormat('en-GB', {
    timeZone: timeZone || 'UTC', day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).format(instant);
  return `${formatted}${zoneLabel ? ` ${zoneLabel}` : ''}`;
}

export function indexMeta(index) {
  const asOf = marketTime(index?.observationAsOf, index?.timeZone, index?.zoneLabel);
  const delay = Number.isFinite(Number(index?.delayMinutes)) ? `${Number(index.delayMinutes)}-minute delayed` : null;
  const provider = index?.providerSymbolLabel ? `Provider ID ${index.providerSymbolLabel}` : index?.source;
  const status = index?.marketStatus && index.marketStatus !== 'unavailable'
    ? `Market ${index.marketStatus}` : null;
  return [asOf ? `As of ${asOf}` : 'Observation timestamp unavailable', delay, status, provider]
    .filter(Boolean).join(' · ');
}

export function moverTime(value, marketStatus) {
  return marketTime(value, marketStatus?.timeZone, marketStatus?.zoneLabel) || 'Unavailable';
}

export function complexCorporateActions(announcements = []) {
  return announcements.filter((announcement) => announcement?.complex === true);
}

export function moverHeading(movers) {
  if (!movers || movers.error || !movers.marketDate) return 'Mover ranking unavailable';
  return `${movers.marketStatus?.label || 'Verified session'} gainers — ${movers.marketDate}`;
}
